// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect, useState } from 'react';
import { graphql } from 'react-relay';

import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';

import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';
import { unit } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import SmallContentContainer from '@zego/components/atoms/SmallContentContainer';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import FormSentSuccessfully from '@zego/components/organisms/FleetBrokerFormSentSuccessfully';
import BrokerInterestForm from '@zego/components/organisms/FleetBrokerInterestForm';
import TestimonialFooter from '@zego/components/organisms/FleetBrokerTestimonialFooter';
import BrokerInterestFormFr from '@zego/components/organisms/fr/FleetBrokerInterestFormFr';
import BrokerInterestFormNL from '@zego/components/organisms/nl/FleetBrokerInterestFormNL';
import SimpleHeader from '@zego/components/SimpleHeader';

function LocalisedForm(props) {
  switch (props.country) {
    case 'GB':
      return (
        <BrokerInterestForm
          onSuccess={props.onSuccess}
          id="broker-interest-form-widget"
        />
      );
    case 'NL':
      return (
        <BrokerInterestFormNL
          onSuccess={props.onSuccess}
          id="broker-interest-form-widget-nl"
          country={props.country}
        />
      );
    case 'FR':
      return (
        <BrokerInterestFormFr
          onSuccess={props.onSuccess}
          id="broker-interest-form-widget-fr"
          country={props.country}
        />
      );
    default:
      return (
        <BrokerInterestForm
          onSuccess={props.onSuccess}
          id="broker-interest-form-widget"
        />
      );
  }
}

const BrokerInterest = ({ viewer }): JSX.Element => {
  const [page, setPage] = useState<number>(1);
  const [brokerName, setBrokerName] = useState<string>('');
  const onSuccess = (v: string) => {
    setBrokerName(v);
    setPage(2);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const isGBCountry = viewer.country.countryAlpha2 === 'GB';

  return (
    <BaseLayout
      viewer={viewer}
      title="Partner with Zego"
      header={<SimpleHeader />}
      hideFooter
    >
      <SmallContentContainer>
        <Spacer height={unit(4)} />
        {page === 1 ? (
          <>
            <VerticalView>
              <H2>
                <Trans id="Partner With Us / Heading">Partner with Zego</Trans>
              </H2>
              <Spacer height={unit(2)} />
              {isGBCountry && (
                <RegularText>
                  <Trans id="Partner With Us / All fields are mandatory">
                    All fields are mandatory
                  </Trans>
                </RegularText>
              )}
            </VerticalView>
            <LocalisedForm
              country={viewer.country.countryAlpha2}
              onSuccess={onSuccess}
            />
          </>
        ) : (
          page === 2 && (
            <FormSentSuccessfully
              brokerName={brokerName}
              country={viewer.country.countryAlpha2}
              isBrokerPage={true}
            />
          )
        )}
        <Spacer height={unit(16)} />
      </SmallContentContainer>
      <TestimonialFooter />
    </BaseLayout>
  );
};

const VerticalView = styled(View)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
});

export default withData(BrokerInterest, {
  query: graphql`
    query partnerWithUsQuery($country: String!) {
      viewer {
        ...BaseLayout_viewer @arguments(country: $country)
        country: countryByCode(code: $country) {
          countryAlpha2
        }
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
